import { PAID_ANALYTICS_PATH } from './paths'

const CLIENT_SCOPED_RESOURCE_ROUTES: Record<string, readonly string[]> = {
    landingpages: ['create'],
    products: ['import'],
    playlists: ['create'],
    videos: ['upload', 'multi-upload'],
    collections: ['create'],
}

const NESTED_CLIENT_SCOPED_ROUTES: Record<string, string> = {
    'analytics/experiment': PAID_ANALYTICS_PATH,
}

export const getClientSwitchRedirectPath = (
    pathname: string,
): string | null => {
    const [prefix, segment, detail] = pathname.split('/').filter(Boolean)
    if (!prefix || !segment) {
        return null
    }

    if (detail !== undefined) {
        const nestedRedirect =
            NESTED_CLIENT_SCOPED_ROUTES[`${prefix}/${segment}`]
        if (nestedRedirect !== undefined) {
            return nestedRedirect
        }
    }

    const staticSegments = CLIENT_SCOPED_RESOURCE_ROUTES[prefix]
    if (staticSegments === undefined || staticSegments.includes(segment)) {
        return null
    }

    return `/${prefix}`
}
